import { render, staticRenderFns } from "./CsPopoverCard.vue?vue&type=template&id=5ab60dfb&"
import script from "./CsPopoverCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsPopoverCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports